// React
import { createContext } from "react"

// Types
import type { DetailType } from "../utils"
import type { RowType } from "../types"

export const DetailContext = createContext<{
  fields: RowType[]
  update: (
    key: number,
    value: DetailType
  ) => void
}>({
  fields: [],
  update(_key, _value) {}
})